import { render, staticRenderFns } from "./deliveries.vue?vue&type=template&id=3e0419e3&scoped=true&"
import script from "./deliveries.vue?vue&type=script&lang=js&"
export * from "./deliveries.vue?vue&type=script&lang=js&"
import style0 from "./deliveries.vue?vue&type=style&index=0&id=3e0419e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0419e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0419e3')) {
      api.createRecord('3e0419e3', component.options)
    } else {
      api.reload('3e0419e3', component.options)
    }
    module.hot.accept("./deliveries.vue?vue&type=template&id=3e0419e3&scoped=true&", function () {
      api.rerender('3e0419e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/deliveries.vue"
export default component.exports